// Pagination, checkbox controllers, sorting.
import Vue from 'vue'
export default {
  data () {
    return {
      tempIDcounter: 0, // counter
      items: [],
      itemView: [], // this is the subset of items that is current in view. The page of items
      pagination: {
        rowCount: 0,
        pages: 0
      },
      selected: {},
      ordering: 'ordering' // or tempID
    }
  },
  computed: {
    selectedCount () {
      return Object.values(this.selected).reduce((a, i) => a + (i === true), 0)
    }
  },
  methods: {
    goToFirstPage () {
      this.page = 0
      this.loadAPI()
    },
    goToLastPage () {
      this.page = this.pagination.pages - 1
      this.loadAPI()
    },
    goToNextPage () {
      this.page ++
      this.loadAPI()
    },
    goToPreviousPage () {
      this.page --
      this.loadAPI()
    },
    updatePageNumber (newPageNumber) {
      var newPage = newPageNumber
      if (!Number.isInteger(newPage)) {
        newPage = 0
      } else if (newPage < 0) {
        newPage = 0
      } else if (newPage > this.pagination.pages - 1) {
        newPage = this.pagination.pages - 1
      }

      this.page = parseInt(newPage)
      this.loadAPI()
    },
    getSelectedRows () {
      // get
      return Object.entries(this.selected).reduce((a, i) => {
        if (i[1]) {
          a.push(parseInt(i[0]))
        }
        return a
      }, [])
    },
    selectAll () {
      for (var item of this.items) {
        Vue.set(this.selected, item.id, true)
      }
    },
    selectPage () {
      for (var item of this.items) {
        Vue.set(this.selected, item.id, true)
      }
    },
    selectNone () {
      this.selected = {}
    },
    checkRow (item) {
      Vue.set(this.selected, item.id, !this.selected[item.id])
    },
    clickSortHeader (column) {
      if (this.filters.sortCol !== column) {
        this.filters.sortAscending = false
      } else {
        this.filters.sortAscending = !this.filters.sortAscending
      }
      this.filters.sortCol = column
    },
    dragChange (event) {
      if (event.moved) {
        /* console.log(event)
        var firstIndexOnPage = this.page * this.filters.rowsPerPage
        this.items.splice(firstIndexOnPage, this.filters.rowsPerPage, ...this.itemView)
        for (const [index, item] of this.items.entries()) {
          item[this.ordering] = this.filters.sortAscending ? index: (this.items.length - 1 - index)
        }
        */
        var orderingArray = this.itemView.map(item => item[this.ordering])
        orderingArray.sort((a, b) => this.filters.sortAscending ? a - b : b - a)
        for (const [index, item] of this.itemView.entries()) {
          item[this.ordering] = orderingArray[index]
        }

        this.loadAPI()
      }
    },
    getNewID () {
      this.tempIDcounter++
      return this.tempIDcounter
    },
    generateIdsAndOrdering () {
      var hstart = performance.now()
      //if (this.items.length !== this.lastTrackedLocalItemsSize) {
        // Array has experienced an addition or delete
      /* if (this.ordering !== null) {
        this.items.sort((a, b) => a[this.ordering] - b[this.ordering])
        for (const [index, item] of this.items.entries()) {
          item[this.ordering] = index
        }
        this.sort(this.sortIndex, this.items, this.sortAscending)
      } */
      //}
      // this.lastTrackedLocalItemsSize = this.items.length
      // generate tempID

      this.items.sort((a, b) => a[this.ordering] - b[this.ordering])
      for (const [index, item] of this.items.entries()) {
        item[this.ordering] = index
      }
      // this.sort(this.sortIndex, this.items, this.sortAscending)
     

      /* for (const [index, item] of this.items.entries()) {
        item[this.ordering] = index
      } */

      this.items.map(item => {
        if (!item.tempID) {
          item.tempID = this.getNewID()
        }
      })
      // var hrend = performance.now()
      // console.log('process time: ' + (hrend - hstart))
    },
  }
}